export type AuthAudience = "customer" | "platform";

export function workspaceAudience(pathname: string): AuthAudience {
  return pathname === "/platform" || pathname.startsWith("/platform/") ? "platform" : "customer";
}

/** Only accept local destinations in the explicitly chosen workspace. */
export function workspaceDestination(audience: AuthAudience, requested: unknown, tenants: { id: string; onboardingStatus?: string }[]): string {
  const fallback = audience === "platform" ? "/platform" : tenants[0]
    ? `/t/${tenants[0].id}/${tenants[0].onboardingStatus === "draft" ? "onboarding" : "dashboard"}` : "/no-access";
  if (typeof requested !== "string" || !requested.startsWith("/") || requested.startsWith("//")
    || /[\\%\s]/u.test(requested)) return fallback;
  const path = requested.split(/[?#]/u)[0]!;
  if (path.split("/").some(part => part === "." || part === "..") || workspaceAudience(path) !== audience) return fallback;
  if (audience === "platform") return path === "/platform/login" || path === "/platform/mfa" ? fallback : requested;
  // Customer return targets must name a workspace the authenticated account owns.
  return tenants.some(tenant => path.startsWith(`/t/${tenant.id}/`)) || path === "/account/security"
    ? requested : fallback;
}
